import React, { useState } from 'react';
import logoImage from '../Navbar/img/logoImage.jpg';
import { useTranslation } from 'react-i18next';


const MemberEngagement = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        district: '',
        clubName: '',
        areaOfInterest: [],
        preferredDays: '',
        preferredTimings: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCheckboxChange = (e) => {
        const { value } = e.target;
        setFormData((prevData) => {
            const updatedAreas = prevData.areaOfInterest.includes(value)
                ? prevData.areaOfInterest.filter((item) => item !== value)
                : [...prevData.areaOfInterest, value];
            return { ...prevData, areaOfInterest: updatedAreas };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation (optional)
        if (!formData.name || !formData.email || !formData.mobile || !formData.district || !formData.clubName) {
            alert('Please fill all required fields');
            return;
        }

        try {
            const response = await fetch('https://api.lionsmd320.org/pages/api/submit-memberengagement', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                alert('Thanks for providing information, our team will get back to you – MD320');
                // Optionally reset form here
                setFormData({
                    name: '',
                    mobile: '',
                    email: '',
                    district: '',
                    clubName: '',
                    areaOfInterest: [],
                    preferredDays: '',
                    preferredTimings: '',
                });
            } else {
                alert(data.error || 'Submission failed');
            }
        } catch (error) {
            alert('Error submitting form: ' + error.message);
        }
    };


    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const interests = [
        'healthCamp',
        'eyeCamp',
        'bloodDonation',
        'hungerFeed',
        'diabetesCamp',
        'awarenessCamps',
        'leadershipTrainings',
        'volunteering',
        'donationToProjects',
        'networking' // ✅ Added
    ];


    return (
        <div style={{ maxWidth: '600px', margin: 'auto', padding: '20px', marginTop: '30px', fontSize: '12px', fontFamily: 'Arial, sans-serif', background: '#ffffff', boxShadow: '0 0 10px rgba(0,0,0,0.1)', }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <img
                    src={logoImage}
                    alt="Lions Club Logo"
                    style={{ width: '100px', height: 'auto' }}
                />
            </div>
            <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#2c3e50' }}>
                {t('formTitle')}
            </h2>

            <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                <label style={{ display: 'block', textAlign: 'right', marginBottom: '2px' }}>SELECT LANGUAGE</label>
                <select onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>
                    <option value="en">English</option>
                    <option value="hi">हिंदी</option>
                    <option value="te">తెలుగు</option>
                    <option value="ta">தமிழ் (Tamil)</option>
                    <option value="bn">বাংলা (Bengali)</option>
                    <option value="mr">मराठी (Marathi)</option>
                    <option value="gu">ગુજરાતી (Gujarati)</option>
                    <option value="kn">ಕನ್ನಡ (Kannada)</option>
                    <option value="ml">മലയാളം (Malayalam)</option>
                    <option value="pa">ਪੰਜਾਬੀ (Punjabi)</option>
                </select>
            </div>

            <form onSubmit={handleSubmit}>
                {[
                    { label: `${t('name')} :`, name: 'name', type: 'text' },
                    { label: `${t('mobile')} :`, name: 'mobile', type: 'text' },
                    { label: `${t('email')} :`, name: 'email', type: 'email' },
                    { label: `${t('clubName')} :`, name: 'clubName', type: 'text' },
                ].map(({ label, name, type }) => (
                    <div style={{ marginBottom: '15px' }} key={name}>
                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }}>{label}</label>
                        <input
                            type={type}
                            name={name}
                            value={formData[name]}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '10px', marginTop: '6px', fontSize: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', }} />
                    </div>
                ))}

                <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '6px' }}>{t('district')} :</label>
                    <select name="district" value={formData.district} onChange={handleChange} style={{ width: '100%', padding: '10px', marginTop: '6px', fontSize: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', }}>
                        <option value="">{t('select')} {t('district')}</option>
                        {['320A', '320B', '320C', '320D', '320E', '320F', '320G', '320H'].map((d) => (
                            <option value={d} key={d}>
                                {d}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }}>{t('areaOfInterest')} :</label>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px', }}>
                        {interests.map((key) => (
                            <label key={key} style={{
                                ...{ border: '1px solid #ddd', borderRadius: '6px', padding: '8px 12px', fontSize: '12px', cursor: 'pointer', backgroundColor: '#f9f9f9', transition: 'all 0.3s ease' },
                                ...(formData.areaOfInterest.includes(t(`areaOptions.${key}`)) ? { backgroundColor: '#d1e7dd', borderColor: '#198754', color: '#155724' } : {})
                            }}>
                                <input
                                    type="checkbox"
                                    value={t(`areaOptions.${key}`)}
                                    onChange={handleCheckboxChange}
                                    checked={formData.areaOfInterest.includes(t(`areaOptions.${key}`))}
                                    style={{ marginRight: '6px' }}
                                />
                                {t(`areaOptions.${key}`)}
                            </label>
                        ))}
                    </div>
                </div>

                <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }}>{t('preferredDays')} :</label>
                    <select name="preferredDays" value={formData.preferredDays} onChange={handleChange} style={{ width: '100%', padding: '10px', marginTop: '6px', fontSize: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', }}>
                        <option value="">{t('select')}</option>
                        <option value="Weekdays">{t('weekdays')}</option>
                        <option value="Weekend">{t('weekend')}</option>
                    </select>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }}>{t('preferredTimings')} :</label>
                    <select name="preferredTimings" value={formData.preferredTimings} onChange={handleChange} style={{ width: '100%', padding: '10px', marginTop: '6px', fontSize: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', }}>
                        <option value="">{t('select')}</option>
                        <option value="7-9am">7 – 9 AM</option>
                        <option value="11-1pm">11 – 1 PM</option>
                        <option value="4-6pm">4 – 6 PM</option>
                        <option value="7-10pm">7 – 10 PM</option>
                    </select>
                </div>

                <div style={{ textAlign: 'center' }}>
                    <button type="submit" style={{ backgroundColor: '#007BFF', color: '#fff', padding: '10px 30px', fontSize: '12px', border: 'none', cursor: 'pointer', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', transition: '0.3s ease', }} onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')} onMouseOut={(e) => (e.target.style.backgroundColor = '#007BFF')}>
                        {t('submit')}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default MemberEngagement;
